import { combineReducers } from "redux";

import { taxesDetails } from "./reducer.taxes"
const taxesReducers = combineReducers({
    taxesDetails
})
export default taxesReducers;
